export default {
  methods: {
    petWeightInputs(pet) {
      return {
        value: pet.weight?.value ? parseFloat(pet.weight.value) : '',
        is_metric: pet.weight?.is_metric ? 1 : 0,
      };
    },
  },
};
